import { gql } from '@apollo/client';
import { ManufacturerInfo } from '../fragments';

// Separate from GET_MANUF so the edit form does not pay for the metric
// aggregates. The metrics field is nested on the backend for the same reason —
// only the show page asks for it.
export default gql`
  query manufacturerShow($id: ID) {
    manufacturer(id: $id) {
      ...ManufacturerInfo
      metrics {
        pfgsThisMonth
        pfgsPast90Days
        pfgsPast6Months
        ordersSentThisMonth
        archesThisMonth
        pfgRateThisMonth
        avgTurnaroundDays
        inFlight
        needsAttention
      }
    }
  }
  ${ManufacturerInfo}
`;
